// libraries
import { useState } from 'react';
import { Modal } from 'antd';
import { MailOutlined } from '@ant-design/icons';

import styled from 'styled-components';

import { txt } from '../../locales/i18n';

export type ModalProps = {
	useVisible: [boolean, (state: boolean) => void];
	onConfirm: (type: string) => void | Promise<void>;
};

export function SendWarningModal(props: ModalProps): JSX.Element {
	const [visible, setVisible] = props.useVisible;
	const [selectedType, setSelectedType] = useState<string>('');

	const types = [
		{type: 'dating', label: '🇩🇰 Dating / flirt eller lign.'},
		{type: 'looking-for-females', label: '🇩🇰 Mand søger veninde(r) i bobl'},
		{type: 'writing-to-females', label: '🇩🇰 Mand skriver kun til kvinder'},
		{type: 'ban-dating', label: '🇩🇰 Banned - Dating / flirt'},
		{type: 'dating-se', label: '🇸🇪 Dating / flirt eller lign.'},
		{type: 'looking-for-females-se', label: '🇸🇪 Mand søger veninde(r) i bobl'},
		{type: 'writing-to-females-se', label: '🇸🇪 Mand skriver kun til kvinder'},
		{type: 'ban-dating-se', label: '🇸🇪 Banned - Dating / flirt'},
	]

	function selectType(type: string) {
		if (type === selectedType) return setSelectedType('')
		setSelectedType(type)
	}

	return (
		<Modal
			visible={visible}
			okText={[<span key={1}>{'Send'}</span>, <MailOutlined key={2} />]}
			cancelText={'Annuller'}
			onOk={() => props.onConfirm(selectedType)}
			onCancel={() => setVisible(false)}
			okButtonProps={{ disabled: selectedType === '' }}
			maskClosable
		>
			<h2>{txt('user.send warning title')}</h2>
			<p>{txt('user.send warning text')}</p>

			<div>
				{types.map(item => (
					<OptionContainer
						key={item.type}
						isSelected={selectedType === item.type}
						onClick={() => selectType(item.type)}
					>
						{item.label}
					</OptionContainer>
				))}
			</div>
		</Modal>
	);
}

const OptionContainer = styled.div<{isSelected: boolean}>`
	display: flex;
	align-items: center;
	border: 1px solid ${props => props.isSelected ? '#1890ff' : '#cccccc'};
	border-radius: 4px;
	padding: 8px;
	margin-bottom: 12px;
	color: ${props => props.isSelected ? '#1890ff' : 'inherit'};

	:hover {
		cursor: pointer;
		box-shadow: 0px 0px 5px rgba(24, 144, 255, 0.27);
	}

	p { 
		margin: 0;
	}
`
